import { TOP_NAV_Z_CLASSNAME } from '@/app/constants/top-navigation';
import { cnva } from '@/app/utils/cnva';

export const TopNavigationStyled = cnva('top-0 left-0 z-40 h-14 w-full', {
  variants: {
    variant: {
      filled: 'sticky',
      transparent:
        'transition-bg-opacity absolute before:absolute before:inset-0 before:shadow-md before:transition-opacity',
    },
    showBackground: {
      true: 'bg-white shadow-md',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'transparent',
      showBackground: false,
      className: 'before:opacity-0',
    },
  ],
  defaultVariants: {
    variant: 'filled',
    showBackground: true,
  },
});

export const TopNavigationInnerStyled = cnva(
  [
    'relative flex h-full items-center justify-between gap-x-4',
    TOP_NAV_Z_CLASSNAME,
  ],
  {
    variants: {
      theme: {
        light: 'text-gray-700',
        dark: 'text-white',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  }
);
